export default {"src":"/_next/static/media/L1_loader.c87e2c9c.gif","height":1500,"width":1500,"blurWidth":0,"blurHeight":0};